import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { IConsoleArticle } from "@/apps/merchant3/types/in-console/InConsoleArticle";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

/**
 * Fetches the in-console messages for the merchant.
 * @param {?number} fromDate - specifies the number of days in the past from which to fetch the messages.
 */
export const getInConsoleMessages = async (
  fromDate: number | null
): Promise<AxiosResponse<Array<IConsoleArticle>>> => {
  const url = M3_API().INCONSOLE_MESSAGES;

  return await jwtApiClient.get(url, {
    params: {
      fromDate: fromDate,
    },
  });
};
